<template>
    <div>
        <template v-if="tiers.length">
            <pricing-table :price="variant.price" :per-unit="variant.unit_qty" :tax="variant.factor_tax" :quantity="realQty" :tiers="variant.tiers" v-on:priced="syncPricing($event)"></pricing-table>

            <div class="row">
            <div class="col-xs-12 col-sm-6">
              <p class="price-per"><a href="#" data-toggle="modal" data-target="#pricingModal">Pricing help <i class="fa fa-question-circle btn-price-help" aria-hidden="true"></i></a></p>
            </div>
          </div>

            <div class="product-order-form">
                <div class="product-qty">
                    <div class="col">
                        <label class="product-qty-label">Boxes <em>of {{ variant.tiers[0].lower_limit }}</em></label>
                    </div>
                    <div class="col product-qty-input">
                        <input type="number" class="form-control" min="0" v-model="boxes" @keyup="quantity = 0" @focus="resetBoxes" @blur="checkAndResetBoxes">
                    </div>
                    <div class="col"></div>
                </div>
            </div>
        </template>

        <div class="product-qty">
            <div class="col">
                <label class="product-qty-label">
                    <span v-if="tiers.length">Individual items</span>
                    <span v-else>Quantity</span>
                </label>
            </div>
            <div class="col product-qty-input">
                <input type="number" class="form-control" min="0" v-model="quantity" @focus="nullQuantityIfOne" @blur="resetQuantity">
            </div>
            <div class="col">
                <div class="product-price">
                    <product-price :price="total.amount" :tax="total.tax"></product-price>
                </div>
            </div>
            <div class="alert alert-orbital-notification product-qty-alert" role="alert" v-if="boxesCheaper"><i class="fa fa-info-circle animated infinite pulse" aria-hidden="true"></i> Why not buy a box? It'll be cheaper.</div>
        </div>
        <div class="btn-area">
            <add-to-basket :name="name" :id="variant.id" :incoming="variant.incoming" :backorder="variant.backorder" :quantity="realQty" :stock="variant.inventory" :shipping="shipping">Add to basket</add-to-basket>
        </div>
    </div>
</template>

<script>
    import Product from '../../Services/Product.js';
    import PricingTable from '../Elements/PricingTable.vue';
    import ProductPrice from '../Product/ProductPrice.vue';
    import AddToBasket from '../Basket/AddToBasket.vue';

    export default {
        props: ['shipping', 'name'],
        components: {
            PricingTable,
            AddToBasket,
            ProductPrice
        },
        data() {
            return {
                service: Product,
                quantity: 1,
                price: 0,
                unit_cost: 0,
                tax: 0,
                boxes: 0
            }
        },
        watch : {
            boxes(val) {
                if (this.quantity == 1) {
                    this.quantity = 0;
                }
            }
        },
        mounted() {
            this.price = this.variant.unit_price;
            this.unit_cost = this.variant.unit_price;
            this.tax = this.variant.unit_tax;
            this.quantity = this.variant.min_batch;
        },
        methods: {
            syncPricing($event) {
                this.price = $event.price;
                this.tax = $event.tax;
                this.unit_cost = $event.price / this.quantity;
            },
            nullQuantityIfOne () {
                if (this.quantity == 1 || this.quantity === null) {
                    this.quantity = null;
                }
            },
            resetBoxes () {
                if (this.boxes === 0) {
                    this.boxes = null
                }
            },
            resetQuantity () {
                if (this.quantity === null) {
                    this.quantity = 1;
                }
            },
            checkAndResetBoxes () {
                if (this.boxes === null) {
                    this.boxes = 0;
                }
            }
        },
        computed: {
            total() {

                const amount = this.tiers.length ? (this.price / this.variant.unit_qty) * this.realQty : this.price;

                let tax = this.tiers.length ? (this.tax / this.variant.unit_qty) * this.realQty : this.tax

                if (this.variant && this.variant.tax) {
                    tax = amount * (this.variant.tax.percentage / 100)
                }


                return {
                    amount,
                    tax
                };
            },
            realQty() {
                let qty = !this.quantity && !this.boxes ? 1 : this.quantity ? this.quantity : 0;
                if (!this.tiers.length) {
                    return qty;
                }
                let boxQty = (this.tiers[0].lower_limit * this.boxes);
                return parseInt(qty) + parseInt(boxQty);
            },
            boxesCheaper() {
                // If no tiers, ignore
                if (!this.tiers.length) {
                    return false;
                }

                const tier = this.tiers[0],
                    factor = tier.lower_limit;

                let currentPrice = this.quantity * (this.price / this.variant.unit_qty),
                    noBoxes = this.quantity / factor;

                if (noBoxes >=  1) {
                    return false;
                }

                // If the number of boxes we can get is less than one
                // then just base off the price of one box.
                let boxPrice = (tier.price / this.variant.unit_qty) * factor;

                return boxPrice < currentPrice;
            },
            variant() {
                return this.service.variant;
            },
            tiers() {
                return this.variant.tiers ? this.variant.tiers : [];
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/Components/Product/VariantPricing.vue